module.exports = flarum.core.compat['utils/string'];